// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__dG2A4","header":"styles_header__1JqJ1","back":"styles_back__UBaTw","title":"styles_title__3CeTG","content":"styles_content__1josp"};